import { render, staticRenderFns } from "./AttendanceRecordsGroupHeaderCard.vue?vue&type=template&id=07bc6802"
import script from "./AttendanceRecordsGroupHeaderCard.vue?vue&type=script&lang=js"
export * from "./AttendanceRecordsGroupHeaderCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports